import React, { useState } from "react";
import ExpandToggleButton from "../../../../../components/ExpandToggleButton";
import RenderWhen from "../../../../../components/RenderWhen";
import { HistoryTableProps } from "../../../@types/rldynamicanalysis";
import HistoryTableRow from "./HistoryTableRow";

const DEFAULT_ROW_COUNT = 5;

const HistoryTable: React.FC<HistoryTableProps> = ({
  data,
  hash,
  isStoredReport,
  isNetworkReport = false,
  onReportClick
}) => {
  const [rowCount, setRowCount] = useState(DEFAULT_ROW_COUNT);
  const displayedData = data?.slice(0, rowCount);
  const totalRowCount = data?.length;
  const showMoreReports = totalRowCount > DEFAULT_ROW_COUNT;
  const updatedRowCount =
    rowCount > DEFAULT_ROW_COUNT ? DEFAULT_ROW_COUNT : totalRowCount;

  return (
    <>
      <table
        className={`rl-cloud-sandbox__history-table${
          isStoredReport ? "" : " clickable"
        }`}
        data-testid="rlcs_analysis_history_table"
      >
        <colgroup>
          <col style={{ width: "40px" }} />
          <col style={{ width: "220px" }} />
          <col style={{ width: "190px" }} />
          <col style={{ width: "120px" }} />
          <col style={{ width: "120px" }} />
          <col />
          <col style={{ width: "50px" }} />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Classification</th>
            <th>Start Time</th>
            <th>Mode</th>
            <th>Duration</th>
            <th>Configuration</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {displayedData.map(rowData => (
            <HistoryTableRow
              key={rowData.analysis_id}
              data={rowData}
              hash={hash}
              isStoredReport={isStoredReport}
              isNetworkReport={isNetworkReport}
              onReportClick={onReportClick}
            />
          ))}
        </tbody>
        <RenderWhen condition={showMoreReports}>
          <tfoot>
            <tr>
              <td colSpan={9}>
                <span className="rl-cloud-sandbox__history-table-row-count">
                  {rowCount} of {totalRowCount} Results
                </span>
                <ExpandToggleButton
                  onClick={() => setRowCount(updatedRowCount)}
                  textCollapsed="Show All"
                  textExpanded={`Show Latest ${DEFAULT_ROW_COUNT}`}
                />
              </td>
            </tr>
          </tfoot>
        </RenderWhen>
      </table>
    </>
  );
};

export default HistoryTable;
